module.exports = __webpack_public_path__ + "media/application/images/blobs/blob_pink-bdf839db65864b053e4d210b8dd724f8.png";